import React from 'react'
import { Outlet } from 'react-router-dom'

const WithdrawComponent = () => {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default WithdrawComponent
